import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getRecoverConversationReturn = {
  name: "getRecoverConversationReturn" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({
    returnId: z.string(),
    returnNumber: z.string().optional(),
    status: z.string(),
    returnTypes: z.array(z.string()),
    createdAt: z.date(),
    products: z.array(
      z.object({
        title: z.string(),
        variantTitle: z.string().optional(),
        imageUrl: z.string().optional(),
        quantity: z.number().optional(),
        reason: z.string().optional(),
      }),
    ),
    recommendation: z
      .object({
        title: z.string().optional(),
        price: z.string().optional(),
        reason: z.string().optional(),
        isSameProduct: z.boolean().optional(),
        imageUrl: z.string().optional(),
      })
      .optional(),
  }),
};
